"use strict";var __importDefault=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{default:t}};Object.defineProperty(exports,"__esModule",{value:!0}),exports.StyledAuthButton=exports.StyledOauthButton=exports.StyledSmallButton=exports.StyledTextButton=void 0;const antd_1=require("antd"),styled_components_1=__importDefault(require("styled-components"));exports.StyledTextButton=styled_components_1.default.button`
  margin: 0;
  padding: 0;
  font-weight: 600;
  font-size: 12px;
  line-height: 22px;
  cursor: pointer;
  color: #1155b6;
  background-color: inherit;
  border : inherit;
  align-self: flex-start;
`,exports.StyledSmallButton=styled_components_1.default.button`
  margin: 0;
  padding: 0;
  font-weight: 400;
  font-size: 12px;
  line-height: 22px;
  cursor: pointer;
  background-color: inherit;
  border : inherit;
  align-self: flex-start;
`,exports.StyledOauthButton=(0,styled_components_1.default)(antd_1.Button)`
  width: 100%;
  height: 45px;
  box-sizing: border-box;
  background-color: white;
  cursor: pointer;
  justify-content: flex-start;
  gap: 8px;
  overflow: hidden;

  /* Gray 8 */
  border: 1px solid #dcdfe8;
  border-radius: 6px;

  /* Inside auto layout */
  display: flex;
  padding: 13px 16px;
  align-items: center;

  img{
    width: 24px;
    height: 24px;
  }

  span {
    flex-shrink: 0;
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
  }

  span:last-child {
    flex-shrink: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  
`,exports.StyledAuthButton=(0,styled_components_1.default)(antd_1.Button)`
  min-width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 50px;
  background-color: #2756B0;
  color: white;
  border-radius: 12px;
  border: none;
  transition: background-color ease-in 0.1s;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  padding: 14px 24px;
  font-family: Poppins;
  cursor: pointer;

  &.big-big-margin {
    margin-top: 50px;
  }

  &.big-margin {
    margin-top: 50px;
  }

  &.middle-margin {
    margin-top: 30px;
  }

  &.small-margin {
    margin-top: 20px;
  }

  & * {
    color: white;
  }
  &:hover {
    opacity: 0.7;
    background-color: #2756B0 !important;
    
  }
  &:disabled {
    opacity: 0.4;
    background-color: #2756B0;
    cursor: not-allowed;
  }
`;